import React, { useEffect, useState } from "react";
import withRouter from "components/Common/withRouter";
import {
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
} from "reactstrap"
import classnames from "classnames"
import { Link, useLocation, useParams } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb";
import toast from "react-hot-toast";
import { updateHomePage, viewHomePage } from "helpers/fakebackend_helper";
import CustomTamilInput from "components/VerticalLayout/CustomTamilInput";
import ImagePopup from "pages/Home-Page/ImagePopup";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const DirectortesTemplate = () => {

    const [activeTab, setactiveTab] = useState(1)
    const [activeTabVartical, setoggleTabVertical] = useState(1)

    const [passedSteps, setPassedSteps] = useState([1])
    const [passedStepsVertical, setPassedStepsVertical] = useState([1])
    const [show, setshow] = useState([true, true, true, true])
    const [navId, setNavId] = useState();
    const [slugs, setSlugs] = useState();
    const { state } = useLocation();
    const [btn, setBtn] = useState(false)
    const [showPopup, setShowPopup] = useState(false)
    const handleClose = () => setShowPopup(false);
    const [image_path, setImage_path] = useState("")

    const { slug } = useParams();



    // console.log('state', state, slug);


    const [tab1, setTab1] = useState({
        image_path: "",
        eng_title: "",
        tamil_title: "",
        eng_sub_title: "",
        tamil_tsub_title: "",
        redirect_url: ""
    })

    const [tab2, setTab2] = useState({
        eng_title: "",
        tamil_title: "",
        eng_about: '',
        tamil_about: '',
        stats:
            [
                { id: 1, eng_title: "", tamil_title: "", stat_value: "" }
            ]
    });


    const [tab3, setTab3] = useState({
        eng_title: "",
        tamil_title: "",
        eng_desc: "",
        tamil_desc: '',
        image_path: '',
        obj_points:
            [
                { id: 1, eng_point: "", tamil_point: "" }
            ]
    });

    const initialTab4 = {
        eng_title: "",
        tamil_title: "",
        programs:
            [
                { id: 1, eng_title: "", tamil_title: "", eng_description: "", tamil_description: "" }
            ]
    }
    
    const [tab4, setTab4] = useState([initialTab4]);

    const [tab5, setTab5] = useState({
        eng_title: "",
        tamil_title: "",
        programs:
            [
                { id: 1, eng_title: "", tamil_title: "", eng_description: "", tamil_description: "" }
            ]
    });

    const handleTab1Change = (e) => {
        const { name, value } = e.target;
        setTab1((p) => ({ ...p, [name]: value }))
    }

    const handleTab2Change = (e) => {
        const { name, value } = e.target;
        setTab2((p) => ({ ...p, [name]: value }))
    }

    const handleTab3Change = (e) => {
        const { name, value } = e.target;
        setTab3((p) => ({ ...p, [name]: value }))
    }

    // const handleTab4Change = (e) => {
    //     const { name, value } = e.target;
    //     setTab4((p) => ({ ...p, [name]: value }))
    // }
    const handleTab4Change = (value, key, index) => {
        setTab4(tab4?.map((p, i) => {
            if(i == index){
                return {...p, [key] : value}
            }
            return p
        }))
    }

    const handleTab5Change = (e) => {
        const { name, value } = e.target;
        setTab5((p) => ({ ...p, [name]: value }))
    }

    const onAddFormRow = () => {
        const newRow = { id: Math.floor(Math.random() * (30 - 20)) + 20, eng_title: "", tamil_title: "", stat_value: "" };
        setTab2({ ...tab2, stats: [...tab2.stats, newRow] });
    };

    const onAddFormRow2 = () => {
        const newRow = { id: Math.floor(Math.random() * (30 - 20)) + 20,  eng_point: "", tamil_point: "" };
        setTab3({ ...tab3, obj_points: [...tab3.obj_points, newRow] });
    };

    const onAddFormRow3 = (index) => {
        const newRow = { id: Math.floor(Math.random() * (30 - 20)) + 20, eng_title: "", tamil_title: "", eng_description: "", tamil_description: "" };
        setTab4(tab4.map((data,i) =>  {
            if(i == index) {
              return { ...data, programs: [...data.programs, newRow] }
            }
            return data
        }));
    };
 
    const onAddFormRow4 = () => {
        const newRow = { id: Math.floor(Math.random() * (30 - 20)) + 20, eng_title: "", tamil_title: "", eng_description: "", tamil_description: ""  };
        setTab5({ ...tab5, programs: [...tab5.programs, newRow] });
    };

    const onDeleteFormRow = (id) => {
        const updatedRows = tab2.stats.filter((row) => row.id !== id);
        setTab2({ ...tab2, stats: updatedRows });
    };

    const onDeleteFormRow2 = (id) => {
        const updatedRows = tab3.obj_points.filter((row) => row.id !== id);
        setTab3({ ...tab3, obj_points: updatedRows });
    };

    const onDeleteFormRow3 = (id, index) => {
        // const updatedRows = tab4.programs.filter((row) => row.id !== id);
        // setTab4({ ...tab4, programs: updatedRows });
        setTab4(tab4.map((data,i) =>  {
            if(i == index) {
              return { ...data, programs: data.programs.filter((row) => row.id !== id) }
            }
            return data
        }));
    };

    const onDeleteFormRow4 = (id) => {
        const updatedRows = tab5.programs.filter((row) => row.id !== id)        
        setTab4({ ...tab5, programs: updatedRows });
    };
    
    const onDeleteFormRow5 = (id) => {
        const updatedRow5 = tab4.programs.filter((row) => row.id !== id)        
        setTab4({ ...tab5, programs: updatedRows });
    };
    


    const handleInputChange = (id, name, value) => {
        const updatedRows = tab2.stats.map(row => {
            if (row.id === id) {
                return { ...row, [name]: value };
            }
            return row;
        });
        setTab2({ ...tab2, stats: updatedRows });
    };


    const handleInputChange2 = (id, name, value) => {
        const updatedRows = tab3.obj_points.map(row => {
            if (row.id === id) {
                return { ...row, [name]: value };
            }
            return row;
        });
        setTab3({ ...tab3, obj_points: updatedRows });
    };


    const handleInputChange3 = (id, name, value, index) => {
        const updatedRows = tab4.map((row, k) => {
            if (k == index) {
                return { ...row, programs: row.programs?.map((val, l) =>  {
                    if (val.id === id) {
                        return { ...val, [name]: value };
                    }
                    return val;
                }) };
            }
            return row;
        });
        setTab4(updatedRows);
    };

    const handleInputChange4 = (id, name, value) => {
        const updatedRows = tab5.programs.map(row => {
            if (row.id === id) {
                return { ...row, [name]: value };
            }
            return row;
        });
        setTab5({ ...tab5, programs: updatedRows });
    };

    const handleTab1Verify = () => {
        if (tab1.tamil_title != "" && tab1.eng_title != "") {
            return true;
        } else {
            toast.error('Enter All Required Feilds!')
            return false
        }
    }

    const handleTab2Verify = () => {
        if (tab2.eng_title != "" && tab2.tamil_title != "" && tab2.eng_desc != "" && tab2.tamil_desc != "") {
            return true;
        } else if (tab2.stats?.length == 0) {
            toast.error('Add Stats Feilds!')
            return false
        } else {
            toast.error('Enter All Required Feilds!')
            return false
        }
    }

    const handleTab3Verify = () => {
        if (tab3.eng_title != "" && tab3.tamil_title != "" && tab3.eng_desc != "" && tab3.tamil_title != "") {
            return true;
        } else if (tab3.obj_points?.length == 0) {
            toast.error('Add objective Feilds!')
            return false
        } else {
            toast.error('Enter All Required Feilds!')
            return false
        }
    }

    const handleTab4Verify = () => {
        if (tab4[0].eng_title != "" && tab4[0].tamil_title != "") {
            return true;
        } else if (tab4?.[0]?.programs.length == 0) {
            toast.error('Add Program Feilds!')
            return false
        } else {
            toast.error('Enter All Required Feilds!')
            return false
        }
    }

    const handleTab5Verify = () => {
        if (tab5.eng_title != "" && tab5.tamil_title != "") {
            return true;
        } else if (tab5?.programs.length == 0) {
            toast.error('Add Program Feilds!')
            return false
        } else {
            toast.error('Enter All Required Feilds!')
            return false
        }
    }


    function toggleTab(tab) {
        if (activeTab !== tab) {
            var modifiedSteps = [...passedSteps, tab]
            if (tab >= 1 && tab <= 5) {
                setactiveTab(tab)
                setPassedSteps(modifiedSteps)
            }
        }
    }

    function toggleTabVertical(tab) {
        if (activeTabVartical !== tab) {
            var modifiedSteps = [...passedStepsVertical, tab]

            if (tab >= 1 && tab <= 4) {
                setoggleTabVertical(tab)
                setPassedStepsVertical(modifiedSteps)
            }
        }
    }

    const [isLoading, setisLoading] = useState(false)


    const getTemplete = (navigation_id) => {
        let payload = new FormData()
        payload.append('navigation_template_id', slug)
        // let payload ={
        //     navigation_id:navigation_id
        // }
        viewHomePage(payload).then((res) => {
            let data = res?.response
            if (data?.banner_json) {
                setTab1(data?.banner_json)
            }

            // TAB 2
            if (data?.about_json) {
                let empowering_section = data?.about_json
                let empowering_lists_ = Object.values(data?.about_json?.stats)
                let empowering_lists = []
                empowering_lists_?.map((item, ind) => {
                    empowering_lists.push({
                        ...item,
                        id: ind + 1
                    })
                })  
                let empowering = {
                    ...empowering_section
                }
                empowering.stats = empowering_lists
                setTab2(empowering)
            }


            if (data?.objective_json) {
                // TAB 3
                let commitment_section = data?.objective_json
                let commitment_lists_ = Object.values(data?.objective_json?.obj_points)
                let commitment_lists = []
                commitment_lists_?.map((item, ind) => {
                    commitment_lists.push({
                        ...item,
                        id: ind + 1
                    })
                })
                let commitment = {
                    ...commitment_section
                }
                commitment.obj_points = commitment_lists
                
                setTab3(commitment)
            }

            if (data?.program_json) {
                // TAB 4
                let gallery_section = data?.program_json
                let gallery_lists_ = Object.values(data?.program_json?.program_lists);
                
                let gallery_lists = []
                gallery_lists_?.map((item, ind) => {
                    gallery_lists.push({
                        ...item,
                        programs : Object.values(item.programs).map((f, k) => ({
                            ...f,
                            id: k + 1
                        })),
                    })
                })
                let gallery = {
                    ...gallery_section
                }                
                gallery.program_lists = gallery_lists;
                // console.log('gallerygallerygallery', gallery);
                if(data?.program_json?.program_lists){
                    setTab4(gallery.program_lists)
                 }
            }

            // if (data?.service_offered_json) {
            //     // TAB 4
            //     let gallery_section = data?.service_offered_json
            //     let gallery_lists_ = Object.values(data?.service_offered_json?.programs)
            //     let gallery_lists = []
            //     gallery_lists_?.map((item, ind) => {
            //         gallery_lists.push({
            //             ...item,
            //             id: ind + 1
            //         })
            //     })
            //     let gallery = {
            //         ...gallery_section
            //     }
            //     gallery.programs = gallery_lists                
            //     setTab5(gallery)
            // }

        }).catch((err) => {
            console.log('err', err);

        })
    }



    useEffect(() => {
        if (state?.data) {
            setNavId(state?.data?.id)
            getTemplete(state?.data?.id)
            setSlugs(state?.data?.id)
        }

        if(slug){
            getTemplete()
        }
    }, [state])

    useEffect(()=> {
        if(slugs){
            getTemplete(slugs)
        }
    },[slugs])


    // console.log('statestatestate', slugs);


    const handleSubmitForm = () => {

        var formData = new FormData();

        formData.append('navigation_template_id', slug)

                // tab 1
                formData.append(`banner_json[image_path]`, tab1?.image_path)
                formData.append(`banner_json[tamil_title]`, tab1?.tamil_title)
                formData.append(`banner_json[eng_title]`, tab1?.eng_title)
        
                // tab 2
                formData.append(`about_json[eng_title]`, tab2?.eng_title)
                formData.append(`about_json[tamil_title]`, tab2?.tamil_title)
                formData.append(`about_json[eng_about]`, tab2?.eng_about)
                formData.append(`about_json[tamil_about]`, tab2?.tamil_about)
             
                tab2?.stats?.map((data, i) => {
                    formData.append(`about_json[stats][${i}][eng_title]`, data.eng_title)
                    formData.append(`about_json[stats][${i}][tamil_title]`, data.tamil_title)
                    formData.append(`about_json[stats][${i}][stat_value]`, data.stat_value)
                })
        
                // tab 3
                formData.append('objective_json[eng_title]', tab3?.eng_title)
                formData.append('objective_json[tamil_title]', tab3?.tamil_title)
                formData.append('objective_json[eng_desc]', tab3?.eng_desc)
                formData.append('objective_json[tamil_desc]', tab3?.tamil_desc)
                formData.append('objective_json[image_path]', tab3?.image_path)
        
                tab3?.obj_points?.map((data, i) => {
                    formData.append(`objective_json[obj_points][${i}][eng_point]`, data.eng_point)
                    formData.append(`objective_json[obj_points][${i}][tamil_point]`, data.tamil_point)
                })
        
                // tab 4
                tab4?.map((data, i) => {
                    formData.append(`program_json[program_lists][${i}][eng_title]`, data.eng_title)
                    formData.append(`program_json[program_lists][${i}][tamil_title]`, data.tamil_title)
                    data.programs.map((item, k) => {
                        formData.append(`program_json[program_lists][${i}][programs][${k}][eng_title]`, item.eng_title)
                        formData.append(`program_json[program_lists][${i}][programs][${k}][tamil_title]`, item.tamil_title)
                        formData.append(`program_json[program_lists][${i}][programs][${k}][eng_description]`, item.eng_description)
                        formData.append(`program_json[program_lists][${i}][programs][${k}][tamil_description]`, item.tamil_description)
                    })
                })
        

                  // tab 5
                //   formData.append('service_offered_json[eng_title]', tab5?.eng_title)
                //   formData.append('service_offered_json[tamil_title]', tab5?.tamil_title)
          
                //   tab5.programs?.map((data, i) => {
                //       formData.append(`service_offered_json[programs][${i}][eng_title]`, data.eng_title)
                //       formData.append(`service_offered_json[programs][${i}][tamil_title]`, data.tamil_title)
                //       formData.append(`service_offered_json[programs][${i}][eng_description]`, data.eng_description)
                //       formData.append(`service_offered_json[programs][${i}][tamil_description]`, data.tamil_description)
                //   })
        

        setisLoading(true)
        updateHomePage(formData).then(res => {
            setisLoading(false)
            if (res?.success) {
                toast.success("Added Success")
                getTemplete(slugs)
                // router(-1)
            } else {
                toast.error(res?.message ?? 'somthing went wrong!')
            }
        }).catch(err => {
            setisLoading(false)
            toast.error(err.message)
        })
    }


    const getImg = (image_) => {
        setImage_path(image_)
        setShowPopup(true)
    }

    return (
        <>
            <ImagePopup showPopup={showPopup} handleClose={handleClose} image_path={image_path} />
            <div className="page-content">
                <Container fluid={true}>
                <Breadcrumb title="Dashboard" breadcrumbItem={state?.data?.type ?? ''} />
                <Row>
                <Col lg="12">
                <Card>
                    <CardBody>
                        {/* <h4 className="card-title mb-4">Home</h4> */}
                        <div className="wizard clearfix">
                            <div className="steps clearfix">
                                <ul>
                                    <NavItem
                                        className={classnames({ current: activeTab === 1 })}
                                    >
                                        <NavLink
                                            className={classnames({ current: activeTab === 1 })}
                                            onClick={() => {
                                                setactiveTab(1)
                                            }}
                                            disabled={!(passedSteps || []).includes(1)}
                                        >
                                            <span className="text-truncate">
                                                <span className="number">1.</span>
                                                Banner
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem
                                        className={classnames({ current: activeTab === 2 })}
                                    >
                                        <NavLink
                                            className={classnames({ active: activeTab === 2 })}
                                            onClick={() => {
                                                setactiveTab(2)
                                            }}
                                            disabled={!(passedSteps || []).includes(2)}
                                        >
                                            <span className="text-truncate">
                                                <span className="number">2.</span>
                                                About
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem
                                        className={classnames({ current: activeTab === 3 })}
                                    >
                                        <NavLink
                                            className={classnames({ active: activeTab === 3 })}
                                            onClick={() => {
                                                setactiveTab(3)
                                            }}
                                            disabled={!(passedSteps || []).includes(3)}
                                        >
                                            <span className="text-truncate">
                                                <span className="number">3.</span> Objective
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem
                                        className={classnames({ current: activeTab === 4 })}
                                    >
                                        <NavLink
                                            className={classnames({ active: activeTab === 4 })}
                                            onClick={() => {
                                                setactiveTab(4)
                                            }}
                                            disabled={!(passedSteps || []).includes(4)}
                                        >
                                            <span className="text-truncate">
                                                <span className="number">4.</span> Program
                                            </span>
                                        </NavLink>
                                    </NavItem>

                                    {/* <NavItem
                                        className={classnames({ current: activeTab === 5 })}
                                    >
                                        <NavLink
                                            className={classnames({ active: activeTab === 5 })}
                                            onClick={() => {
                                                setactiveTab(5)
                                            }}
                                            disabled={!(passedSteps || []).includes(5)}
                                        >
                                            <span className="text-truncate">
                                                <span className="number">5.</span> Service Offered
                                            </span>
                                        </NavLink>
                                    </NavItem> */}
                                </ul>
                            </div>

                        <div className="content clearfix">
                            <TabContent activeTab={activeTab} className="body">
                                <TabPane tabId={1}>
                                    {/* <div className="d-flex justify-content-end w-100">
                                        <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                            setshow((p) => {
                                                const h = [...p];
                                                h[0] = !h[0];
                                                return h;
                                            })
                                        }}>{show[0] ? "Show" : 'Hidden'}</button>
                                    </div> */}

                                    <Form>
                                        <Row>
                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label for="basicpill-firstname-input1">
                                                        English Title <span className="text-danger">*</span>
                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        name="eng_title"
                                                        onChange={handleTab1Change}
                                                        value={tab1?.eng_title}
                                                        className="form-control"
                                                        id="basicpill-firstname-input1"
                                                        placeholder="Enter English Title"
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label for="basicpill-lastname-input2">
                                                        Tamil Title <span className="text-danger">*</span>
                                                    </Label>
                                                    <CustomTamilInput
                                                        value={tab1.tamil_title}
                                                        setValue={(e) => setTab1((p) => ({ ...p, tamil_title: e }))}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg="6">
                                                <div className="mb-3">
                                                    <Label for="imag">
                                                        Image <span className="text-danger">*</span>
                                                    </Label>
                                                    <Input
                                                        type="file"
                                                        onChange={(e) => setTab1((p) => ({ ...p, image_path: e.target.files[0] }))}
                                                        className="form-control"
                                                        id="imag"
                                                        placeholder="Enter Your Email ID"
                                                    />
                                                </div>

                                                {tab1?.image_path && <button type="button" className="btn btn-primary" onClick={() => {
                                                    getImg(tab1?.image_path)
                                                }}>Preview</button>}
                                            </Col>
                                        </Row>
                                    </Form>
                                </TabPane>

                                <TabPane tabId={2}>
                                    <div>
                                        {/* <div className="d-flex justify-content-end w-100">
                                                <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                                    setshow((p) => {
                                                        const h = [...p];
                                                        h[1] = !h[1];
                                                        return h;
                                                    })
                                                }}>{show[1] ? "Show" : 'Hidden'}</button>
                                            </div> */}
                                        <Form>
                                            <Row>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-eng-input5">
                                                            English Title <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            name="eng_title"
                                                            onChange={handleTab2Change}
                                                            className="form-control"
                                                            id="basicpill-eng-input5"
                                                            placeholder="Enter English Title."
                                                            value={tab2?.eng_title}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-hgsd-input6">
                                                            Tamil Title <span className="text-danger">*</span>
                                                        </Label>
                                                        <CustomTamilInput
                                                            value={tab2.tamil_title}
                                                            name={'tamil_title'}
                                                            setValue={(e) => setTab2((p) => ({ ...p, tamil_title: e }))}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-suib-input7">
                                                            English About <span className="text-danger">*</span>
                                                        </Label>
                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            data={tab2.eng_about}
                                                            onChange={(event, editor) => {
                                                                const data = editor.getData();
                                                                setTab2((p) => ({ ...p, eng_about: data }))
                                                            }}
                                                            config={{
                                                                toolbar: {
                                                                    items:  [
                                                                        'undo',
                                                                        'redo',
                                                                        '|',
                                                                        'bold',
                                                                        'italic',
                                                                        '|',
                                                                        'numberedList', // Added numbered list button
                                                                        'bulletedList',  // Added bulleted list button
                                                                      ],
                                                                    maxWordCount: 10,
                                                                },
                                                                // plugins: [
                                                                //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                                                // ],
                                                                // licenseKey: '<YOUR_LICENSE_KEY>',
                                                                mention: {
                                                                    // Mention configuration
                                                                },
                                                            }}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-ygksd-input8">
                                                            Tamil About <span className="text-danger">*</span>
                                                        </Label>
                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            data={tab2.tamil_about}
                                                            onChange={(event, editor) => {
                                                                const data = editor.getData();
                                                                setTab2((p) => ({ ...p, tamil_about: data }))
                                                                // setBody(data)
                                                                // threshHoldDefault1(data?.replace(/<[^>]*>/g, ''));
                                                                // console.log("....", editor.getData()?.replace(/<[^>]*>/g, ''))
                                                            }}
                                                            config={{
                                                                toolbar: {
                                                                    items:  [
                                                                        'undo',
                                                                        'redo',
                                                                        '|',
                                                                        'bold',
                                                                        'italic',
                                                                        '|',
                                                                        'numberedList', // Added numbered list button
                                                                        'bulletedList',  // Added bulleted list button
                                                                      ],
                                                                    maxWordCount: 10,
                                                                },
                                                                // plugins: [
                                                                //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                                                // ],
                                                                // licenseKey: '<YOUR_LICENSE_KEY>',
                                                                mention: {
                                                                    // Mention configuration
                                                                },
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                        <h6 className="mb-3 mt-3 card-title">Stats <span className="text-danger">*</span></h6>
                                        <Form className="repeater" encType="multipart/form-data" >
                                            <div>
                                                {(tab2.stats || []).map((formRow, key) => (
                                                    <Row key={key} className="align-items-center">
                                                        <Col lg={6} className="mb-3">
                                                            <label htmlFor="emp_eng_title">English Title<span className="text-danger">*</span></label>
                                                            <input
                                                                type="text"
                                                                id="eng_title"
                                                                name={`eng_title_${formRow.id}`}
                                                                value={formRow.eng_title}
                                                                onChange={(e) => handleInputChange(formRow.id, 'eng_title', e.target.value)}
                                                                className="form-control"
                                                                placeholder="Enter English Title"
                                                            />
                                                        </Col>

                                                        <Col lg={6} className="mb-3">
                                                            <label htmlFor="tamil_title">Tamil Title<span className="text-danger">*</span></label>
                                                            <CustomTamilInput
                                                                value={formRow.tamil_title}
                                                                name={`tamil_title_${formRow.id}`}
                                                                setValue={(e) => handleInputChange(formRow.id, 'tamil_title', e)}
                                                            />
                                                        </Col>

                                                        <Col lg={6} className="mb-3">
                                                            <label htmlFor="stat_value">State Value<span className="text-danger">*</span></label>

                                                            <input
                                                                type="text"
                                                                id="stat_value"
                                                                name={`stat_value_${formRow.id}`}
                                                                value={formRow.stat_value}
                                                                onChange={(e) => handleInputChange(formRow.id, 'stat_value', e.target.value)}
                                                                className="form-control"
                                                                placeholder="Enter English Sub Title"
                                                            />
                                                        </Col>

                                      {key > 0 &&                  <Col lg={2} className="mb-2 align-self-center">
                                                            <div className="d-grid">
                                                                <input
                                                                    type="button"
                                                                    className="btn btn-danger"
                                                                    value="Delete"
                                                                    onClick={() => onDeleteFormRow(formRow.id)}
                                                                />
                                                            </div>
                                                        </Col>}
                                                    </Row>
                                                ))}
                                            </div>
                                            <input
                                                type="button"
                                                className="btn btn-success mt-3 mt-lg-0"
                                                value="Add Stats"
                                                onClick={() => onAddFormRow()}
                                            />
                                        </Form>
                                    </div>
                                </TabPane>

                                <TabPane tabId={3}>
                                    <div>
                                        {/* <div className="d-flex justify-content-end w-100">
                                    <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                        setshow((p) => {
                                            const h = [...p];
                                            h[2] = !h[2];
                                            return h;
                                        })
                                    }}>{show[2] ? "Show" : 'Hidden'}</button>
                                </div> */}

                                        <Form>
                                            <Row>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-eng-input5">
                                                            English Title <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            name="eng_title"
                                                            onChange={handleTab3Change}
                                                            className="form-control"
                                                            id="basicpill-eng-input5"
                                                            placeholder="Enter English Title."
                                                            value={tab3?.eng_title}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-hgsd-input6">
                                                            Tamil Title <span className="text-danger">*</span>
                                                        </Label>
                                                        <CustomTamilInput
                                                            value={tab3.tamil_title}
                                                            name={'tamil_title'}
                                                            setValue={(e) => setTab3((p) => ({ ...p, tamil_title: e }))}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-suib-input7">
                                                            English Desc <span className="text-danger">*</span>
                                                        </Label>
                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            data={tab3.eng_desc}
                                                            onChange={(event, editor) => {
                                                                const data = editor.getData();
                                                                setTab3((p) => ({ ...p, eng_desc: data }))
                                                            }}
                                                            config={{
                                                                toolbar: {
                                                                    items:  [
                                                                        'undo',
                                                                        'redo',
                                                                        '|',
                                                                        'bold',
                                                                        'italic',
                                                                        '|',
                                                                        'numberedList', // Added numbered list button
                                                                        'bulletedList',  // Added bulleted list button
                                                                      ],
                                                                    maxWordCount: 10,
                                                                },
                                                                // plugins: [
                                                                //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                                                // ],
                                                                // licenseKey: '<YOUR_LICENSE_KEY>',
                                                                mention: {
                                                                    // Mention configuration
                                                                },
                                                            }}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-ygksd-input8">
                                                            Tamil Desc <span className="text-danger">*</span>
                                                        </Label>
                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            data={tab3.tamil_desc}
                                                            onChange={(event, editor) => {
                                                                const data = editor.getData();
                                                                setTab3((p) => ({ ...p, tamil_desc: data }))
                                                                // setBody(data)
                                                                // threshHoldDefault1(data?.replace(/<[^>]*>/g, ''));
                                                                // console.log("....", editor.getData()?.replace(/<[^>]*>/g, ''))
                                                            }}
                                                            config={{
                                                                toolbar: {
                                                                    items:  [
                                                                        'undo',
                                                                        'redo',
                                                                        '|',
                                                                        'bold',
                                                                        'italic',
                                                                        '|',
                                                                        'numberedList', // Added numbered list button
                                                                        'bulletedList',  // Added bulleted list button
                                                                      ],
                                                                    maxWordCount: 10,
                                                                },
                                                                // plugins: [
                                                                //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                                                // ],
                                                                // licenseKey: '<YOUR_LICENSE_KEY>',
                                                                mention: {
                                                                    // Mention configuration
                                                                },
                                                            }}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="imag">
                                                            Image Path <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            type="file"
                                                            onChange={(e) => setTab3((p) => ({ ...p, image_path: e.target.files[0] }))}
                                                            className="form-control"
                                                            id="imag"
                                                        />
                                                    </div>

                                                    {tab3?.image_path && <button type="button" className="btn btn-primary" onClick={() => {
                                                        getImg(tab3?.image_path)
                                                    }}>Preview</button>}
                                                </Col>
                                            </Row>
                                        </Form>

                                        <h6 className="mb-3 mt-3 card-title">Objective <span className="text-danger">*</span></h6>
                                        <Form className="repeater" encType="multipart/form-data" >
                                            <div>
                                                {(tab3.obj_points || []).map((formRow, key) => (
                                                    <Row key={key} className="align-items-center">
                                                        <Col lg={6} className="mb-3">
                                                            <label htmlFor="comm_eng_title">English Point<span className="text-danger">*</span></label>
                                                            <input
                                                                type="text"
                                                                id="eng_point"
                                                                name={`eng_point_${formRow.id}`}
                                                                value={formRow.eng_point}
                                                                onChange={(e) => handleInputChange2(formRow.id, 'eng_point', e.target.value)}
                                                                className="form-control"
                                                                placeholder="Enter English Title"
                                                            />
                                                        </Col>

                                                        <Col lg={6} className="mb-3">
                                                            <label htmlFor="comm_tamil_title">Tamil Point<span className="text-danger">*</span></label>
                                                            <CustomTamilInput
                                                                value={formRow.tamil_point}
                                                                name={`tamil_point${formRow.id}`}
                                                                setValue={(e) => handleInputChange2(formRow.id, 'tamil_point', e)}
                                                            />
                                                        </Col>

                                                  {key > 0 &&      <Col lg={2} className="mb-2 align-self-center">
                                                            <div className="d-grid">
                                                                <input
                                                                    type="button"
                                                                    className="btn btn-danger"
                                                                    value="Delete"
                                                                    onClick={() => onDeleteFormRow2(formRow.id)}
                                                                />
                                                            </div>
                                                        </Col>}
                                                    </Row>
                                                ))}
                                            </div>
                                            <input
                                                type="button"
                                                className="btn btn-success mt-3 mt-lg-0"
                                                value="Add Objective"
                                                onClick={() => onAddFormRow2()}
                                            />
                                        </Form>
                                    </div>
                                </TabPane>

                                <TabPane tabId={4}>
                                    {
                                        tab4.map((form, index) =>  (
                                            <div key={index}>

                                                <Form>
                                                    <Row className="mb-3"> 
                                                        {
                                                            index != 0 && (
                                                            <Col lg="12" className="d-flex justify-content-end mb-2">
                                                                    <input
                                                                    type="button"
                                                                    className="btn btn-danger"
                                                                    value={`Remove Program Form ${index+1}`}
                                                                    onClick={() => setTab4((p) => p.filter((u,o) => o != index))}
                                                                />
                                                            </Col>
                                                            )
                                                        }
                                                    {/* <h6 className="mb-3 mt-3 card-title">Programs Form {index+1}<span className="text-danger">*</span></h6> */}
                                                    <Col lg="6">
                                                            <div className="mb-3">
                                                                <Label for="basicpill-eng-input5">
                                                                    English Title <span className="text-danger">*</span>
                                                                </Label>
                                                                <Input
                                                                    type="text"
                                                                    name="eng_title"
                                                                    onChange={(e) =>  handleTab4Change(e.target.value,'eng_title', index)}
                                                                    className="form-control"
                                                                    id="basicpill-eng-input5"
                                                                    placeholder="Enter English Title."
                                                                    value={form?.eng_title}
                                                                />
                                                            </div>
                                                        </Col>

                                                        <Col lg="6">
                                                            <div className="mb-3">
                                                                <Label for="basicpill-hgsd-input6">
                                                                    Tamil Title <span className="text-danger">*</span>
                                                                </Label>
                                                                <CustomTamilInput
                                                                    value={form.tamil_title}
                                                                    name={'tamil_title'}
                                                                    setValue={(e) => handleTab4Change(e,'tamil_title', index)}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Form>

                                                <h6 className="mb-3 mt-3 card-title">Programs {index+1}<span className="text-danger">*</span></h6>
                                                <Form className="repeater" encType="multipart/form-data" >
                                                    <div>
                                                        {(form.programs || []).map((formRow, key) => (
                                                            <Row key={key} className="align-items-center">
                                                                <Col lg={6} className="mb-3">
                                                                    <label htmlFor="eng_title">English Title<span className="text-danger">*</span></label>
                                                                    <input
                                                                        type="text"
                                                                        id="eng_title"
                                                                        name={`eng_title_${formRow.id}`}
                                                                        value={formRow.eng_title}
                                                                        onChange={(e) => handleInputChange3(formRow.id, 'eng_title', e.target.value, index)}
                                                                        className="form-control"
                                                                        placeholder="Enter English Title"
                                                                    />
                                                                </Col>

                                                                <Col lg={6} className="mb-3">
                                                                    <label htmlFor="tamil_title">Tamil Title<span className="text-danger">*</span></label>
                                                                    <CustomTamilInput
                                                                        value={formRow.tamil_title}
                                                                        name={`tamil_title_${formRow.id}`}
                                                                        setValue={(e) => handleInputChange3(formRow.id, 'tamil_title', e, index)}
                                                                    />
                                                                </Col> 

                                                            <Col lg="6">
                                                                <div className="mb-3">
                                                                    <Label for="basicpill-suib-input7">
                                                                        English Desc <span className="text-danger">*</span>
                                                                    </Label>
                                                                    <CKEditor
                                                                        editor={ClassicEditor}
                                                                        data={formRow.eng_description}
                                                                            onChange={(event, editor) => {
                                                                            const data = editor.getData();
                                                                            handleInputChange3(formRow.id, 'eng_description', data, index)
                                                                        }}
                                                                        config={{
                                                                            toolbar: {
                                                                                items:  [
                                                                                    'undo',
                                                                                    'redo',
                                                                                    '|',
                                                                                    'bold',
                                                                                    'italic',
                                                                                    '|',
                                                                                    'numberedList', // Added numbered list button
                                                                                    'bulletedList',  // Added bulleted list button
                                                                                ],
                                                                                maxWordCount: 10,
                                                                            },
                                                                        }}
                                                                    />
                                                                </div>
                                                            </Col>

                                                            <Col lg="6">
                                                                <div className="mb-3">
                                                                    <Label for="basicpill-ygksd-input8">
                                                                        Tamil Desc <span className="text-danger">*</span>
                                                                    </Label>
                                                                    <CKEditor
                                                                        editor={ClassicEditor}
                                                                        data={formRow.tamil_description}
                                                                        onChange={(event, editor) => {
                                                                            const data = editor.getData();
                                                                            handleInputChange3(formRow.id, 'tamil_description', data, index)
                                                                        }}
                                                                        config={{
                                                                            toolbar: {
                                                                                items:  [
                                                                                    'undo',
                                                                                    'redo',
                                                                                    '|',
                                                                                    'bold',
                                                                                    'italic',
                                                                                    '|',
                                                                                    'numberedList', // Added numbered list button
                                                                                    'bulletedList',  // Added bulleted list button
                                                                                ],
                                                                                maxWordCount: 10,
                                                                            },
                                                                            // plugins: [
                                                                            //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                                                            // ],
                                                                            // licenseKey: '<YOUR_LICENSE_KEY>',
                                                                            mention: {
                                                                                // Mention configuration
                                                                            },
                                                                        }}
                                                                    />
                                                                </div>
                                                            </Col>
                                                                
                                                        {key > 0 &&
                                                                <Col lg={2} className="mb-2 align-self-center">
                                                                    <div className="d-grid">
                                                                        <input
                                                                            type="button"
                                                                            className="btn btn-danger"
                                                                            value="Delete"
                                                                            onClick={() => onDeleteFormRow3(formRow.id, index)}
                                                                        />
                                                                    </div>
                                                                </Col>}
                                                            </Row>
                                                        ))}
                                                    </div>
                                                    <input
                                                        type="button"
                                                        className="btn btn-success mt-3 mt-lg-0"
                                                        value="Add Program"
                                                        onClick={() => onAddFormRow3(index)}
                                                    />
                                                </Form>
                                            </div>
                                        ) )
                                    }
                                    <Col lg="12" className="d-flex justify-content-end  mb-2">
                                        <input
                                        type="button"
                                        className="btn btn-success mt-3 mt-lg-0"
                                        value="Add Program Form"
                                        onClick={() => setTab4((p) => [...p, initialTab4])}
                                    />
                                    </Col>
                                </TabPane>

                                {/* <TabPane tabId={5}>
                                    <div>
                                        <Form>
                                            <Row>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-eng-input5">
                                                            English Title <span className="text-danger">*</span>
                                                        </Label>
                                                        <Input
                                                            type="text"
                                                            name="eng_title"
                                                            onChange={handleTab5Change}
                                                            className="form-control"
                                                            id="basicpill-eng-input5"
                                                            placeholder="Enter English Title."
                                                            value={tab5?.eng_title}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-hgsd-input6">
                                                            Tamil Title <span className="text-danger">*</span>
                                                        </Label>
                                                        <CustomTamilInput
                                                            value={tab5.tamil_title}
                                                            name={'tamil_title'}
                                                            setValue={(e) => setTab5((p) => ({ ...p, tamil_title: e }))}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>

                            <h6 className="mb-3 mt-3 card-title">Programs<span className="text-danger">*</span></h6>
                            <Form className="repeater" encType="multipart/form-data" >
                                <div>
                                    {(tab5.programs || []).map((formRow, key) => (
                                        <Row key={key} className="align-items-center">
                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="eng_title">English Title</label>
                                                <input
                                                    type="text"
                                                    id="eng_title"
                                                    name={`eng_title_${formRow.id}`}
                                                    value={formRow.eng_title}
                                                    onChange={(e) => handleInputChange4(formRow.id, 'eng_title', e.target.value)}
                                                    className="form-control"
                                                    placeholder="Enter English Title"
                                                />
                                            </Col>

                                            <Col lg={6} className="mb-3">
                                                <label htmlFor="tamil_title">Tamil Title</label>
                                                <CustomTamilInput
                                                    value={formRow.tamil_title}
                                                    name={`tamil_title_${formRow.id}`}
                                                    setValue={(e) => handleInputChange4(formRow.id, 'tamil_title', e)}
                                                />
                                            </Col> 

                                        <Col lg="6">
                                            <div className="mb-3">
                                                <Label for="basicpill-suib-input7">
                                                    English Desc <span className="text-danger">*</span>
                                                </Label>
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    data={formRow.eng_description}
                                                        onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        handleInputChange4(formRow.id, 'eng_description', data)
                                                    }}
                                                    config={{
                                                        toolbar: {
                                                            items:  [
                                                                'undo',
                                                                'redo',
                                                                '|',
                                                                'bold',
                                                                'italic',
                                                                '|',
                                                                'numberedList', // Added numbered list button
                                                                'bulletedList',  // Added bulleted list button
                                                              ],
                                                            maxWordCount: 10,
                                                        },
                                                        // plugins: [
                                                        //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                                        // ],
                                                        // licenseKey: '<YOUR_LICENSE_KEY>',
                                                        mention: {
                                                            // Mention configuration
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </Col>

                                        <Col lg="6">
                                            <div className="mb-3">
                                                <Label for="basicpill-ygksd-input8">
                                                    Tamil Desc <span className="text-danger">*</span>
                                                </Label>
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    data={formRow.tamil_description}
                                                    onChange={(event, editor) => {
                                                        const data = editor.getData();
                                                        handleInputChange4(formRow.id, 'tamil_description', data)
                                                    }}
                                                    config={{
                                                        toolbar: {
                                                            items:  [
                                                                'undo',
                                                                'redo',
                                                                '|',
                                                                'bold',
                                                                'italic',
                                                                '|',
                                                                'numberedList', // Added numbered list button
                                                                'bulletedList',  // Added bulleted list button
                                                              ],
                                                            maxWordCount: 10,
                                                        },
                                                        // plugins: [
                                                        //   Bold, Essentials, Italic, Mention, Paragraph, SlashCommand, Undo
                                                        // ],
                                                        // licenseKey: '<YOUR_LICENSE_KEY>',
                                                        mention: {
                                                            // Mention configuration
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                            

                                      {key > 0 &&      <Col lg={2} className="mb-2 align-self-center">
                                                <div className="d-grid">
                                                    <input
                                                        type="button"
                                                        className="btn btn-danger"
                                                        value="Delete"
                                                        onClick={() => onDeleteFormRow4(formRow.id)}
                                                    />
                                                </div>
                                            </Col>}
                                        </Row>
                                    ))}
                                </div>
                                <input
                                    type="button"
                                    className="btn btn-success mt-3 mt-lg-0"
                                    value="Add Service"
                                    onClick={() => onAddFormRow4()}
                                />
                            </Form>
                                    </div>
                                </TabPane> */}
                            </TabContent>
                        </div>

                            <div className="actions clearfix">
                                <ul>
                                    <li
                                        className={
                                            activeTab === 1 ? "previous disabled" : "previous"
                                        }
                                    >
                                        <button
                                            onClick={() => {
                                                toggleTab(activeTab - 1)
                                            }}
                                        >
                                            Previous
                                        </button>
                                    </li>
                                    <li
                                        className={activeTab === 5 ? "next" : "next"}
                                    >

                                        {
                                            activeTab === 4 ?

                                                <button type="button" onClick={() => handleSubmitForm()} className="btn btn-primary">
                                                    {
                                                        isLoading ?
                                                            <>
                                                                <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                                                Loading
                                                            </>
                                                            :
                                                            "Submit"
                                                    }
                                                </button>
                                                :

                                                <button
                                                    onClick={() => {
                                                        if (activeTab == 1) {

                                                            if (!show[0] || handleTab1Verify()) {
                                                                toggleTab(activeTab + 1)
                                                            }
                                                        } else if (activeTab == 2) {
                                                            if (!show[1] || handleTab2Verify()) {
                                                                toggleTab(activeTab + 1)
                                                            }
                                                        } else if (activeTab == 3) {
                                                            if (!show[2] || handleTab3Verify()) {
                                                                toggleTab(activeTab + 1)
                                                            }
                                                        } else if (activeTab == 4) {
                                                            if (!show[0] || handleTab4Verify()) {
                                                                toggleTab(activeTab + 1)
                                                            } 
                                                        } 
                                                        // else if (activeTab == 5) {
                                                        //     if (handleTab5Verify()) {
                                                        //         toggleTab(activeTab + 1)
                                                        //     } 
                                                        // }
                                                    }}
                                                >
                                                    Next
                                                </button>
                                        }
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </CardBody>
                </Card>
                </Col>
                </Row>
                </Container>
            </div>
        </>
    )
}


export default withRouter(DirectortesTemplate);